import _slicedToArray from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["isDisabled", "isQuiet", "isReadOnly", "isRequired", "onChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { useLayoutEffect as $evhxb$useLayoutEffect, chain as $evhxb$chain, mergeProps as $evhxb$mergeProps } from "@react-aria/utils";
import $evhxb$react, { useRef as $evhxb$useRef, useCallback as $evhxb$useCallback, useImperativeHandle as $evhxb$useImperativeHandle, cloneElement as $evhxb$cloneElement, forwardRef as $evhxb$forwardRef } from "react";
import { useControlledState as $evhxb$useControlledState } from "@react-stately/utils";
import { useProviderProps as $evhxb$useProviderProps } from "@react-spectrum/provider";
import { useTextField as $evhxb$useTextField } from "@react-aria/textfield";
import $evhxb$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $evhxb$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import { createFocusableRef as $evhxb$createFocusableRef, classNames as $evhxb$classNames } from "@react-spectrum/utils";
import { Field as $evhxb$Field } from "@react-spectrum/label";
import { useFocusRing as $evhxb$useFocusRing } from "@react-aria/focus";
import { useHover as $evhxb$useHover } from "@react-aria/interactions";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $c14528ddc146317f$exports = {};
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-input", function () {
  return $c14528ddc146317f$export$1ac009feb2b0bd0c;
}, function (v) {
  return $c14528ddc146317f$export$1ac009feb2b0bd0c = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield", function () {
  return $c14528ddc146317f$export$2c8a10299d8b3418;
}, function (v) {
  return $c14528ddc146317f$export$2c8a10299d8b3418 = v;
});
$parcel$export($c14528ddc146317f$exports, "focus-ring", function () {
  return $c14528ddc146317f$export$f39a09f249340e2a;
}, function (v) {
  return $c14528ddc146317f$export$f39a09f249340e2a = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield--quiet", function () {
  return $c14528ddc146317f$export$bffd5e3d61a81737;
}, function (v) {
  return $c14528ddc146317f$export$bffd5e3d61a81737 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield--multiline", function () {
  return $c14528ddc146317f$export$9699f1c538a448a0;
}, function (v) {
  return $c14528ddc146317f$export$9699f1c538a448a0 = v;
});
$parcel$export($c14528ddc146317f$exports, "is-placeholder", function () {
  return $c14528ddc146317f$export$e5b2f5233e4e5194;
}, function (v) {
  return $c14528ddc146317f$export$e5b2f5233e4e5194 = v;
});
$parcel$export($c14528ddc146317f$exports, "is-hovered", function () {
  return $c14528ddc146317f$export$b8813cd5d7824ce7;
}, function (v) {
  return $c14528ddc146317f$export$b8813cd5d7824ce7 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield--valid", function () {
  return $c14528ddc146317f$export$c2abbc3f970170b7;
}, function (v) {
  return $c14528ddc146317f$export$c2abbc3f970170b7 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield--invalid", function () {
  return $c14528ddc146317f$export$58e50b10d30123df;
}, function (v) {
  return $c14528ddc146317f$export$58e50b10d30123df = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield--loadable", function () {
  return $c14528ddc146317f$export$14fd30fea6f1348c;
}, function (v) {
  return $c14528ddc146317f$export$14fd30fea6f1348c = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-wrapper", function () {
  return $c14528ddc146317f$export$dd1165e0e6012973;
}, function (v) {
  return $c14528ddc146317f$export$dd1165e0e6012973 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-wrapper--quiet", function () {
  return $c14528ddc146317f$export$9fcb3d6af94a9d12;
}, function (v) {
  return $c14528ddc146317f$export$9fcb3d6af94a9d12 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-validationIcon", function () {
  return $c14528ddc146317f$export$cf0ead5b44db0da3;
}, function (v) {
  return $c14528ddc146317f$export$cf0ead5b44db0da3 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-icon", function () {
  return $c14528ddc146317f$export$222d1ccd1870be1d;
}, function (v) {
  return $c14528ddc146317f$export$222d1ccd1870be1d = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-inputIcon", function () {
  return $c14528ddc146317f$export$c1cdcaa5fe76a871;
}, function (v) {
  return $c14528ddc146317f$export$c1cdcaa5fe76a871 = v;
});
$parcel$export($c14528ddc146317f$exports, "spectrum-Textfield-circleLoader", function () {
  return $c14528ddc146317f$export$82a249fb4d6127;
}, function (v) {
  return $c14528ddc146317f$export$82a249fb4d6127 = v;
});
$parcel$export($c14528ddc146317f$exports, "is-focused", function () {
  return $c14528ddc146317f$export$e7dc768d35940237;
}, function (v) {
  return $c14528ddc146317f$export$e7dc768d35940237 = v;
});
$parcel$export($c14528ddc146317f$exports, "is-disabled", function () {
  return $c14528ddc146317f$export$d35bc1e505d1ebbf;
}, function (v) {
  return $c14528ddc146317f$export$d35bc1e505d1ebbf = v;
});
var $c14528ddc146317f$export$1ac009feb2b0bd0c;
var $c14528ddc146317f$export$2c8a10299d8b3418;
var $c14528ddc146317f$export$f39a09f249340e2a;
var $c14528ddc146317f$export$bffd5e3d61a81737;
var $c14528ddc146317f$export$9699f1c538a448a0;
var $c14528ddc146317f$export$e5b2f5233e4e5194;
var $c14528ddc146317f$export$b8813cd5d7824ce7;
var $c14528ddc146317f$export$c2abbc3f970170b7;
var $c14528ddc146317f$export$58e50b10d30123df;
var $c14528ddc146317f$export$14fd30fea6f1348c;
var $c14528ddc146317f$export$dd1165e0e6012973;
var $c14528ddc146317f$export$9fcb3d6af94a9d12;
var $c14528ddc146317f$export$cf0ead5b44db0da3;
var $c14528ddc146317f$export$222d1ccd1870be1d;
var $c14528ddc146317f$export$c1cdcaa5fe76a871;
var $c14528ddc146317f$export$82a249fb4d6127;
var $c14528ddc146317f$export$e7dc768d35940237;
var $c14528ddc146317f$export$d35bc1e505d1ebbf;
$c14528ddc146317f$export$1ac009feb2b0bd0c = "spectrum-Textfield-input_73bc77";
$c14528ddc146317f$export$2c8a10299d8b3418 = "spectrum-Textfield_73bc77";
$c14528ddc146317f$export$f39a09f249340e2a = "focus-ring_73bc77";
$c14528ddc146317f$export$bffd5e3d61a81737 = "spectrum-Textfield--quiet_73bc77";
$c14528ddc146317f$export$9699f1c538a448a0 = "spectrum-Textfield--multiline_73bc77";
$c14528ddc146317f$export$e5b2f5233e4e5194 = "is-placeholder_73bc77";
$c14528ddc146317f$export$b8813cd5d7824ce7 = "is-hovered_73bc77";
$c14528ddc146317f$export$c2abbc3f970170b7 = "spectrum-Textfield--valid_73bc77";
$c14528ddc146317f$export$58e50b10d30123df = "spectrum-Textfield--invalid_73bc77";
$c14528ddc146317f$export$14fd30fea6f1348c = "spectrum-Textfield--loadable_73bc77";
$c14528ddc146317f$export$dd1165e0e6012973 = "spectrum-Textfield-wrapper_73bc77";
$c14528ddc146317f$export$9fcb3d6af94a9d12 = "spectrum-Textfield-wrapper--quiet_73bc77";
$c14528ddc146317f$export$cf0ead5b44db0da3 = "spectrum-Textfield-validationIcon_73bc77";
$c14528ddc146317f$export$222d1ccd1870be1d = "spectrum-Textfield-icon_73bc77";
$c14528ddc146317f$export$c1cdcaa5fe76a871 = "spectrum-Textfield-inputIcon_73bc77";
$c14528ddc146317f$export$82a249fb4d6127 = "spectrum-Textfield-circleLoader_73bc77";
$c14528ddc146317f$export$e7dc768d35940237 = "is-focused_73bc77";
$c14528ddc146317f$export$d35bc1e505d1ebbf = "is-disabled_73bc77";
function $599adb75312e6492$var$TextFieldBase(props, ref) {
  var validationState = props.validationState,
    icon = props.icon,
    _props$isQuiet = props.isQuiet,
    isQuiet = _props$isQuiet === void 0 ? false : _props$isQuiet,
    isDisabled = props.isDisabled,
    multiLine = props.multiLine,
    autoFocus = props.autoFocus,
    inputClassName = props.inputClassName,
    wrapperChildren = props.wrapperChildren,
    labelProps = props.labelProps,
    inputProps = props.inputProps,
    descriptionProps = props.descriptionProps,
    errorMessageProps = props.errorMessageProps,
    userInputRef = props.inputRef,
    isLoading = props.isLoading,
    loadingIndicator = props.loadingIndicator,
    validationIconClassName = props.validationIconClassName,
    disableFocusRing = props.disableFocusRing;
  var _$evhxb$useHover = $evhxb$useHover({
      isDisabled: isDisabled
    }),
    hoverProps = _$evhxb$useHover.hoverProps,
    isHovered = _$evhxb$useHover.isHovered;
  var domRef = $evhxb$useRef(null);
  var defaultInputRef = $evhxb$useRef(null);
  var inputRef = userInputRef || defaultInputRef;
  // Expose imperative interface for ref
  $evhxb$useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, $evhxb$createFocusableRef(domRef, inputRef)), {}, {
      select: function select() {
        if (inputRef.current) inputRef.current.select();
      },
      getInputElement: function getInputElement() {
        return inputRef.current;
      }
    });
  });
  var ElementType = multiLine ? 'textarea' : 'input';
  var isInvalid = validationState === 'invalid' && !isDisabled;
  if (icon) {
    var UNSAFE_className = $evhxb$classNames( /*@__PURE__*/$parcel$interopDefault($c14528ddc146317f$exports), icon.props && icon.props.UNSAFE_className, 'spectrum-Textfield-icon');
    icon = /*#__PURE__*/$evhxb$cloneElement(icon, {
      UNSAFE_className: UNSAFE_className,
      size: 'S'
    });
  }
  var validationIcon = isInvalid ? /*#__PURE__*/$evhxb$react.createElement($evhxb$spectrumiconsuiAlertMedium, null) : /*#__PURE__*/$evhxb$react.createElement($evhxb$spectrumiconsuiCheckmarkMedium, null);
  var validation = /*#__PURE__*/$evhxb$cloneElement(validationIcon, {
    UNSAFE_className: $evhxb$classNames( /*@__PURE__*/$parcel$interopDefault($c14528ddc146317f$exports), 'spectrum-Textfield-validationIcon', validationIconClassName)
  });
  var _$evhxb$useFocusRing = $evhxb$useFocusRing({
      isTextInput: true,
      autoFocus: autoFocus
    }),
    focusProps = _$evhxb$useFocusRing.focusProps,
    isFocusVisible = _$evhxb$useFocusRing.isFocusVisible;
  var textField = /*#__PURE__*/$evhxb$react.createElement("div", {
    className: $evhxb$classNames( /*@__PURE__*/$parcel$interopDefault($c14528ddc146317f$exports), 'spectrum-Textfield', {
      'spectrum-Textfield--invalid': isInvalid,
      'spectrum-Textfield--valid': validationState === 'valid' && !isDisabled,
      'spectrum-Textfield--loadable': loadingIndicator,
      'spectrum-Textfield--quiet': isQuiet,
      'spectrum-Textfield--multiline': multiLine,
      'focus-ring': !disableFocusRing && isFocusVisible
    })
  }, /*#__PURE__*/$evhxb$react.createElement(ElementType, _objectSpread(_objectSpread({}, $evhxb$mergeProps(inputProps, hoverProps, focusProps)), {}, {
    ref: inputRef,
    rows: multiLine ? 1 : undefined,
    className: $evhxb$classNames( /*@__PURE__*/$parcel$interopDefault($c14528ddc146317f$exports), 'spectrum-Textfield-input', {
      'spectrum-Textfield-inputIcon': icon,
      'is-hovered': isHovered
    }, inputClassName)
  })), icon, validationState && !isLoading && !isDisabled ? validation : null, isLoading && loadingIndicator, wrapperChildren);
  return /*#__PURE__*/$evhxb$react.createElement($evhxb$Field, _objectSpread(_objectSpread({}, props), {}, {
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    wrapperClassName: $evhxb$classNames( /*@__PURE__*/$parcel$interopDefault($c14528ddc146317f$exports), 'spectrum-Textfield-wrapper', {
      'spectrum-Textfield-wrapper--quiet': isQuiet
    }),
    showErrorIcon: false,
    ref: domRef
  }), textField);
}
var $599adb75312e6492$export$d22444a338b6e3c2 = /*#__PURE__*/$evhxb$forwardRef($599adb75312e6492$var$TextFieldBase);
function $cc187bf91f8eea73$var$TextArea(props, ref) {
  props = $evhxb$useProviderProps(props);
  var _props = props,
    _props$isDisabled = _props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isQuiet2 = _props.isQuiet,
    isQuiet = _props$isQuiet2 === void 0 ? false : _props$isQuiet2,
    _props$isReadOnly = _props.isReadOnly,
    isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
    _props$isRequired = _props.isRequired,
    isRequired = _props$isRequired === void 0 ? false : _props$isRequired,
    onChange = _props.onChange,
    otherProps = _objectWithoutProperties(_props, _excluded);
  // not in stately because this is so we know when to re-measure, which is a spectrum design
  var _$evhxb$useControlled = $evhxb$useControlledState(props.value, props.defaultValue, function () {}),
    _$evhxb$useControlled2 = _slicedToArray(_$evhxb$useControlled, 2),
    inputValue = _$evhxb$useControlled2[0],
    setInputValue = _$evhxb$useControlled2[1];
  var inputRef = $evhxb$useRef(null);
  var onHeightChange = $evhxb$useCallback(function () {
    // Quiet textareas always grow based on their text content.
    // Standard textareas also grow by default, unless an explicit height is set.
    if ((isQuiet || !props.height) && inputRef.current) {
      var input = inputRef.current;
      var prevAlignment = input.style.alignSelf;
      var prevOverflow = input.style.overflow;
      // Firefox scroll position is lost when overflow: 'hidden' is applied so we skip applying it.
      // The measure/applied height is also incorrect/reset if we turn on and off
      // overflow: hidden in Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1787062
      var isFirefox = ('MozAppearance' in input.style);
      if (!isFirefox) input.style.overflow = 'hidden';
      input.style.alignSelf = 'start';
      input.style.height = 'auto';
      // offsetHeight - clientHeight accounts for the border/padding.
      input.style.height = "".concat(input.scrollHeight + (input.offsetHeight - input.clientHeight), "px");
      input.style.overflow = prevOverflow;
      input.style.alignSelf = prevAlignment;
    }
  }, [isQuiet, inputRef, props.height]);
  $evhxb$useLayoutEffect(function () {
    if (inputRef.current) onHeightChange();
  }, [onHeightChange, inputValue, inputRef]);
  if (props.placeholder) console.warn('Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/TextArea.html#help-text');
  var _$evhxb$useTextField = $evhxb$useTextField(_objectSpread(_objectSpread({}, props), {}, {
      onChange: $evhxb$chain(onChange, setInputValue),
      inputElementType: 'textarea'
    }), inputRef),
    labelProps = _$evhxb$useTextField.labelProps,
    inputProps = _$evhxb$useTextField.inputProps,
    descriptionProps = _$evhxb$useTextField.descriptionProps,
    errorMessageProps = _$evhxb$useTextField.errorMessageProps;
  return /*#__PURE__*/$evhxb$react.createElement($599adb75312e6492$export$d22444a338b6e3c2, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    inputRef: inputRef,
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    multiLine: true,
    isDisabled: isDisabled,
    isQuiet: isQuiet,
    isReadOnly: isReadOnly,
    isRequired: isRequired
  }));
}
/**
 * TextAreas are multiline text inputs, useful for cases where users have
 * a sizable amount of text to enter. They allow for all customizations that
 * are available to text fields.
 */
var $cc187bf91f8eea73$export$f5c9f3c2c4054eec = /*#__PURE__*/$evhxb$react.forwardRef($cc187bf91f8eea73$var$TextArea);
function $265457f9427aa380$var$TextField(props, ref) {
  props = $evhxb$useProviderProps(props);
  var inputRef = $evhxb$useRef(null);
  var _$evhxb$useTextField2 = $evhxb$useTextField(props, inputRef),
    labelProps = _$evhxb$useTextField2.labelProps,
    inputProps = _$evhxb$useTextField2.inputProps,
    descriptionProps = _$evhxb$useTextField2.descriptionProps,
    errorMessageProps = _$evhxb$useTextField2.errorMessageProps;
  if (props.placeholder) console.warn('Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/TextField.html#help-text');
  return /*#__PURE__*/$evhxb$react.createElement($599adb75312e6492$export$d22444a338b6e3c2, _objectSpread(_objectSpread({}, props), {}, {
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    ref: ref,
    inputRef: inputRef
  }));
}
/**
 * TextFields are text inputs that allow users to input custom text entries
 * with a keyboard. Various decorations can be displayed around the field to
 * communicate the entry requirements.
 */
var $265457f9427aa380$export$2c73285ae9390cec = /*#__PURE__*/$evhxb$forwardRef($265457f9427aa380$var$TextField);
export { $cc187bf91f8eea73$export$f5c9f3c2c4054eec as TextArea, $265457f9427aa380$export$2c73285ae9390cec as TextField, $599adb75312e6492$export$d22444a338b6e3c2 as TextFieldBase };